import * as Random from './Random';

export { Random };
